(() => {
  'use strict';
  if (window.__tfPagesReady) return;
  window.__tfPagesReady = true;

  const deliveryVerified = () => {
    try { return sessionStorage.getItem('delivery_verified') === 'true'; }
    catch (_) { return false; }
  };
  const announce = (message) => {
    if (typeof window.TPFU?.announce === 'function') window.TPFU.announce(message);
  };

  function initNavigation(scope = document) {
    scope.querySelectorAll('[data-tf-mobile-nav]').forEach((menu) => {
      if (menu.dataset.tfReady) return;
      menu.dataset.tfReady = 'true';
      const toggle = menu.querySelector('summary');
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) { menu.open = false; toggle.focus(); }
      });
      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) menu.open = false;
      });
      document.addEventListener('click', (event) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
      document.addEventListener('focusin', (event) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
    });
  }

  function initCart(scope = document) {
    scope.querySelectorAll('[data-tf-cart-form]').forEach((form) => {
      if (form.dataset.tfReady) return;
      form.dataset.tfReady = 'true';
      const errorBox = form.querySelector('[data-tf-cart-error]');
      const status = form.querySelector('[data-tf-delivery-status]');
      const verifyButton = form.querySelector('[data-tf-check-delivery]');
      const showError = (message, focus = false) => {
        if (!errorBox) return;
        errorBox.textContent = message;
        errorBox.hidden = !message;
        if (focus && message) errorBox.focus();
      };
      const refreshDelivery = () => {
        const verified = deliveryVerified();
        if (status) status.textContent = verified
          ? 'Delivery area checked. Use the same address at checkout.'
          : 'Check that we deliver to your address before checkout.';
        if (verifyButton) {
          verifyButton.hidden = typeof window.TPFU?.openDelivery !== 'function';
          verifyButton.innerHTML = verified
            ? 'Check another address <span aria-hidden="true">↗</span>'
            : 'Check delivery area <span aria-hidden="true">↗</span>';
        }
        if (verified) showError('');
      };
      const openDelivery = () => {
        if (typeof window.TPFU?.openDelivery !== 'function') return false;
        try { return window.TPFU.openDelivery() !== false; }
        catch (_) {
          showError('The address checker could not open. You can continue to checkout to check delivery availability.');
          return false;
        }
      };
      verifyButton?.addEventListener('click', () => {
        if (!openDelivery()) showError('Continue to checkout to check delivery availability for your shipping address.');
      });
      form.querySelectorAll('[data-tf-quantity]').forEach((control) => {
        const input = control.querySelector('[data-tf-quantity-input]');
        const buttons = control.querySelectorAll('[data-tf-quantity-change]');
        const sync = () => {
          const value = Number(input.value);
          buttons.forEach((button) => {
            button.disabled = Number(button.dataset.tfQuantityChange) < 0 && value <= 0;
          });
        };
        buttons.forEach((button) => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const current = Number(input.value);
            const quantity = Number.isInteger(current) && current >= 0 ? current : 0;
            input.value = String(Math.max(0, quantity + Number(button.dataset.tfQuantityChange)));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        input.addEventListener('input', sync);
        input.addEventListener('change', () => {
          sync();
          const note = form.querySelector('[data-tf-cart-update-note]');
          if (note) note.textContent = 'Your quantities changed. Update your cart to see the new total.';
          announce('Quantity changed. Update your cart to refresh the total.');
        });
        sync();
      });
      form.addEventListener('invalid', () => showError('Enter a whole-number quantity of zero or more. Zero removes an item.'), true);
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          showError('Check your quantities before continuing.', true);
          form.reportValidity();
          return;
        }
        if (event.submitter?.name !== 'checkout') { showError(''); return; }
        if (deliveryVerified()) { showError(''); return; }
        // This is a convenience check. Native Shopify checkout remains available
        // if JavaScript or the address checker is unavailable.
        if (openDelivery()) {
          event.preventDefault();
          showError('Check your delivery address, then continue to checkout.');
        }
      });
      refreshDelivery();
      window.addEventListener('focus', refreshDelivery);
      window.addEventListener('pageshow', refreshDelivery);
      document.addEventListener('tf:delivery-verified', refreshDelivery);
      window.addEventListener('storage', refreshDelivery);
    });
  }

  function init(scope = document) { initNavigation(scope); initCart(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('tf:cart-updated', (event) => {
    const count = event.detail?.cart?.item_count ?? event.detail?.item_count;
    if (!Number.isFinite(Number(count))) return;
    document.querySelectorAll('[data-tf-cart-count]').forEach((badge) => { badge.textContent = String(count); });
  });
})();
